import Swal from 'sweetalert2';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";
import { LOGOUT } from "@/utils/logout.js";
import { MAIN_CONTROLLER } from "@/utils/main_controller.js";

export default {
  name: 'SubWorkflowPage',
  props: {
    
  },
  components: {
    ClientLogo
  },
  mixins: [LOGOUT, MAIN_CONTROLLER],
  data() {
    return {
      searchQuery: '',
      workflows: [],
      service_name: "",
      parentWorkflowName: '',
            currentPage: 1,
      itemsPerPage: 4
    };
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },

    get_service_id(){
      return this.$store.getters.get_service_id;
    },

    filteredWorkflows() {
      if (!this.searchQuery) {
        return this.workflows;
      }
      
      const query = this.searchQuery.toLowerCase();
      return this.workflows.filter(workflow => 
        workflow.router_name.toLowerCase().includes(query)
      );
    },

    paginatedWorkflows() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.filteredWorkflows.slice(startIndex, endIndex);
    },
    
    totalPages() {
      return Math.ceil(this.filteredWorkflows.length / this.itemsPerPage);
    },
    
    showPagination() {
      return this.filteredWorkflows.length > this.itemsPerPage;
    },
    
    canGoBack() {
      return this.currentPage > 1;
    },

    showSearchBar() {
      return this.workflows.length > 4;
    },
    
    canGoForward() {
      return this.currentPage < this.totalPages;
    },

    ServiceName() {
    // Return the service name
    return this.service_name
    }
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }


    this.fetch_service_name();
    this.fetch_sub_workflows();
    
  },

  created() {

    this.fetch_sub_workflows();
  },

  methods: {
    
    fetch_service_name() {
        const token = localStorage.getItem('token');
        const base_url = API_BASE_URL;
        
        Swal.fire({
            text: 'Loading...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        
        $.ajax({
            method: 'GET',
            url: `${base_url}/verify_api/service_management_api/get_workflow_service_name/`,
            data: {
                workflow_id: this.workflow_id
            },
            headers: {
                Authorization: `Token ${token}`
            },
            success: (response) => {
                Swal.close();
                if (response.status === 'success') {
                    this.service_name = response.data.service_name;
                } else {
                    this.serviceName = 'Sub-Workflow Service';
                }
            },
            error: (xhr) => {
                Swal.close();
                console.error('Error fetching service name:', xhr);
                this.serviceName = 'Sub-Workflow Service';
            }
        });
    },

    back_to_dashboard(){
      this.$router.push('/assigned_workflows');

    },


   fetch_sub_workflows() {
        const token = localStorage.getItem('token');
        const base_url = API_BASE_URL;
        const url = `${base_url}/verify_api/service_management_api/check_sub_workflows/?workflow_id=${this.workflow_id}`;

        Swal.fire({
          text: 'Loading sub-workflows...',
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Token ${token}`
          }
        })
        .then(response => response.json())
        .then(data => {
          Swal.close();
          if (data.status === 'success') {

            // Extract the parent workflow name
            if (data.data.workflow_name) {
              // Handle if it's an array with a comma in the Python code
              if (Array.isArray(data.data.workflow_name)) {
                this.parentWorkflowName = data.data.workflow_name[0];
              } else {

                this.parentWorkflowName = data.data.workflow_name;

              }
            }

            // Get the list of completed workflows from localStorage
            const completedWorkflows = JSON.parse(localStorage.getItem('completed_workflows') || '[]');
            
      
            var combined_workflows = [];

            if (Array.isArray(data.data.sub_workflows)) {
              const active_workflows = data.data.sub_workflows.filter(
                workflow => workflow.is_active === true
              );
              
              if (active_workflows.length > 0) {
                combined_workflows = combined_workflows.concat(
                  active_workflows.map(workflow => ({
                    workflow_id: workflow.workflow_id,
                    service_name: workflow.service.service_name,
                    router_name: workflow.router_name,
                    description: workflow.description || 'Click to proceed with this sub-workflow',
                    sub_workflow_type: 'internal',
                    allow_multiple_onboarding: workflow.allow_multiple_onboarding || false, 
                    service_workflow_id: workflow.id,
                    completed: completedWorkflows.includes(workflow.workflow_id.toString())
                  }))
                );
              }
            }

         
            if (Array.isArray(data.data.sub_external_workflows)) {
              const activeExternalWorkflows = data.data.sub_external_workflows.filter(
                workflow => workflow.is_active === true
              );
              
              if (activeExternalWorkflows.length > 0) {
                combined_workflows = combined_workflows.concat(
                  activeExternalWorkflows.map(workflow => ({
                    workflow_id: '',
                    service_name: workflow.service.service_name,
                    router_name: workflow.router_name,
                    description: workflow.description || 'Click to open external workflow',
                    external_url: workflow.external_link,
                    sub_workflow_type: 'external',
                    allow_multiple_onboarding: false,
                    
                    completed: false
                  }))
                );
              }
            }

            
            this.workflows = combined_workflows;
            
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Unable to Load Sub-Workflows',
              text: 'Please try again later',
              timer: 3000,
              timerProgressBar: true,
              showConfirmButton: false
            });
          }
        })
        .catch(error => {
          Swal.close();
          Swal.fire({
            icon: 'error',
            title: 'Error Loading Sub-Workflows',
            text: error.message || 'An error occurred while loading sub-workflows',
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false
          });
        });
      },
    nextPage() {
      if (this.canGoForward) {
        this.currentPage++;
      }
    },
    
    previousPage() {
      if (this.canGoBack) {
        this.currentPage--;
      }
    },

    proceed_with_personal_onboarding(workflow) {
      const token = localStorage.getItem('token');
      const base_url = API_BASE_URL;
      
      localStorage.setItem('parent_workflow_id', this.workflow_id);
      localStorage.setItem('selected_workflow_id', workflow.workflow_id);

      const get_customer_application_url = `${base_url}/verify_api/service_management_api/create_sub_workflow_application/`;
      $.ajax({
        method: 'POST',
        url: get_customer_application_url,
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${token}`
        },
        data: JSON.stringify({ 
          workflow_id: workflow.workflow_id,
          parent_service_workflow_id: workflow.service_workflow_id,
          parent_workflow_id: this.workflow_id,
          is_on_behalf: false
        }),
        beforeSend: () => {
          Swal.fire({
            text: 'Loading ...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          })
        },
        success: (response) => {
          Swal.close();
          if (response.status === 'success') {
      
            this.$store.dispatch('update_workflow_id', workflow.workflow_id);
            this.fetch_current_service();
          }
        },
        error: (xhr) => {
          Swal.close();
          const error_msg = xhr.responseJSON?.message || 'Failed to continue with application.';
          Swal.fire({
            icon: 'error',
            title: 'System Error',
            text: error_msg,
            timer: 3000,
            timerProgressBar: true,
            showConfirmButton: false
          });
        }
      });
    },

  redirect_to_onbehalf(workflow) {
    
    localStorage.setItem('onboarding_workflow_id', workflow.workflow_id);
    localStorage.setItem('onboarding_parent_id', this.workflow_id);
    localStorage.setItem('onboarding_service_workflow_id', workflow.service_workflow_id);

    this.$router.push({ name: 'on_behalf_onboarding' });
    },

    client_application_sub_workflow(workflow) {
        if (workflow.sub_workflow_type === 'internal') {
        
          if (workflow.completed && !workflow.allow_multiple_onboarding) {
     
            return;
          }

      
          Swal.fire({
            title: 'Onboarding Options',
            text: 'Who are you completing this workflow for?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'For myself',
            cancelButtonText: 'For someone else',
            reverseButtons: true
          }).then((result) => {
            if (result.isConfirmed) {
              
              this.proceed_with_personal_onboarding(workflow);
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              
              this.redirect_to_onbehalf(workflow);
            }
          });
        } else {
        
          window.open(workflow.external_url, '_blank');
        }
      },
  }
};
